export enum FEATURE_FLAGS {
  ENABLE_LANGUES_DEMO_SIMPLE_CARDS = "mw-langues-demo-simple-cards",
  ENABLE_VOICES_SLIDER_NO_AUTOSCROLL = "mw-voices-slider-no-autoscroll",
  ENABLE_VOICE_CHANGER_SOFT_NUDGE_V2 = "mw-voice-changer-soft-nudge-v2",
  ENABLE_VOICE_CLONING_SOFT_NUDGE_V2 = "mw-voice-cloning-soft-nudge-v2",
  ENABLE_NAV_CTA_TEST = "mw-default-add-contact-sales-to-contextual-nav",
  ENABLE_MUSIC_CATEGORY_V2 = "mw-music-category-redesign-no-ugc-3",
  ENABLE_TTS_SOCIAL_PROOF_LAUREL_ITERATION = "mw-tts-social-proof-laurel-iteration",
  ENABLE_ELVENLABS_PAGE = "mw-elvenlabs-page",
  ENABLE_AGENTS_FORTUNE_500_SOCIAL_PROOF = "mw-agents-fortune-500-social-proof",
  ENABLE_FLOATING_AGENT_REDESIGN = "mw-floating-agent-redesign",
  ENABLE_PRICING_API_V2 = "mw-pricing-api-v2",
}
